const QRCodeMixin = {
  methods: {
    /**
     * 创建二维码
     * @returns {Promise<void>}
     */
    async createQRCode() {
      const { success, data } = await this.$http({
        url: this.$api.makeQRCode,
        method: 'post',
      })
      if (success) {
        this.$store.commit('editor/setQRCodeID', data)
        this.$store.commit('setRouter', { name: 'Editor' })
      }
    },
  },
}
export default QRCodeMixin
